module.exports = __webpack_public_path__ + "img/slide1.1be72419.jpg";